import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[section]'
})
export class SectionDirective implements OnInit {
  @Input() sectionId!: string;
  @Input() sectionLabel!: string;
  @Input() sectionListable: boolean = true;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {
  }

  ngOnInit(): void {
    if (!this.sectionId) {
      console.warn('SectionDirective: brak sectionId na hostcie', this.elementRef.nativeElement);
    } else {
      this.elementRef.nativeElement.setAttribute('id', this.sectionId);
    }
  }

  getMetadata() {
    return {
      id: this.sectionId,
      label: this.sectionLabel,
      listable: this.sectionListable
    };
  }
}
